import {EntityWithCreatedAtMetadata} from '../entity/entityWithCreatedAtMetadata';
import {UserSummaryConverter} from '../../account/modules/user/api/converter/userSummary.converter';
import {Injectable} from '@angular/core';
import {DateConverter} from './date.converter';

@Injectable({
    providedIn: 'root'
})
export class EntityWithCreatedAtMetadataConverter {

    constructor(
        private userSummaryConverter: UserSummaryConverter,
        private dateConverter: DateConverter){
    }

    public convert <T extends EntityWithCreatedAtMetadata>(target: T, entity: T): T {
        target.createdAt = this.dateConverter.convert(entity.createdAt);
        target.createdBy = this.userSummaryConverter.convert(entity.createdBy);
        return target;
    }
}
